export default {
  path: 'usr-company/:idElement',
  name: 'SicuraSolutionMyUsrCompany',
  component: () => import('@/views/private/MyUsrCompany.vue'),
  props: true,
  children: [
    {
      path: 'communications-preference',
      name: 'SicuraSolutionCommunicationsPreference',
      component: () => import('@/components/my-usr-company/CommunicationsPreference.vue'),
    },
  ],
};
